import { Box, Button, Paper, Typography } from '@mui/material';
import React from 'react';

/**
 * Newsletter call-to-action.
 *
 * The headline used to promise "15% Off Your First Order". Checkout has no
 * promo-code field, so there is no way to redeem a discount on
 * kbrosleather.com — a shopper who signed up expecting one hit a checkout that
 * couldn't honour it. The copy now promises only what the list actually
 * delivers. If you want to run a real 15%-off offer on the storefront,
 * checkout needs promo-code support first.
 */
function NewsletterSignup() {
  return (
    <Box sx={{ padding: 3 }}>
      <Paper sx={{ p: 3, maxWidth: 400, mx: 'auto' }}>
        <Typography variant="h5" component="h2" sx={{ mb: 2 }}>
          New pieces, first look
        </Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Join the list for new designs, restocks and subscriber-only offers.
          A few emails a year — never more.
        </Typography>
        <Button
          variant="contained"
          fullWidth
          href="https://email.everbee.io/subscribe?shopName=KBrosLeather&ref=AKSaNVJp"
          target="_blank"
          rel="noopener noreferrer"
        >
          Sign Up
        </Button>
      </Paper>
    </Box>
  );
}

export default NewsletterSignup;
